import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
import { defineComponent as _defineComponent } from 'vue';
import AzImg from '~/components/Atoms/AzImg.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'GenericCategoryItemGraphql',
  props: {
    tilesList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var route = useRoute();
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      $trackers = _useNuxt2App.$trackers;
    var filteredCategoriesList = computed(function () {
      return props.tilesList.filter(function (item) {
        var _item$link$slug, _item$link;
        return (_item$link$slug = (_item$link = item.link) === null || _item$link === void 0 ? void 0 : _item$link.slug) !== null && _item$link$slug !== void 0 ? _item$link$slug : item.pageLink;
      });
    });
    var isTotalItemsOdd = computed(function () {
      return filteredCategoriesList.value.length % 2 !== 0;
    });
    var getSlug = function getSlug(tile) {
      var _tile$link;
      return tile === null || tile === void 0 ? void 0 : (_tile$link = tile.link) === null || _tile$link === void 0 ? void 0 : _tile$link.slug;
    };
    function getImage(tile) {
      var _tile$backgroundImage, _tile$backgroundImage2;
      return (_tile$backgroundImage = tile === null || tile === void 0 ? void 0 : (_tile$backgroundImage2 = tile.backgroundImage) === null || _tile$backgroundImage2 === void 0 ? void 0 : _tile$backgroundImage2.url) !== null && _tile$backgroundImage !== void 0 ? _tile$backgroundImage : '';
    }
    var getPathObject = function getPathObject(tile) {
      var pathMappings = {
        PageRecipeList: {
          name: 'recipes-slug',
          paramKey: 'slug'
        },
        PageAdviceListing: {
          name: 'pages-slug',
          paramKey: 'slug'
        },
        PageBasic: {
          name: 'legacy-Basic-slug',
          paramKey: 'slug'
        }
      };
      var tileContentType = tile.link.__typename;
      var mapping = pathMappings[tileContentType];
      if (mapping) {
        return {
          name: mapping.name,
          params: _defineProperty({}, mapping.paramKey, getSlug(tile))
        };
      }
    };
    function getLink(tile) {
      return tile.pageLink || app.localePath(getPathObject(tile));
    }
    return {
      __sfc: true,
      props: props,
      route: route,
      app: app,
      $trackers: $trackers,
      filteredCategoriesList: filteredCategoriesList,
      isTotalItemsOdd: isTotalItemsOdd,
      getSlug: getSlug,
      getImage: getImage,
      getPathObject: getPathObject,
      getLink: getLink,
      AzImg: AzImg
    };
  }
});